import moment from 'moment-timezone';

import React from 'react';
import styled, {
  // css,
} from 'styled-components';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

import {
  LinkOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
} from '@ant-design/icons';

import { Tooltip } from 'hive-admin/src/components/Popover';

import Tag from 'antd/lib/tag';
import List from 'antd/lib/list';
// import Button from 'antd/lib/button';
import Avatar from 'antd/lib/avatar';
import Descriptions from 'antd/lib/descriptions';
import AntdTable from 'antd/lib/table';
// import AntdRate from 'antd/lib/rate';

// import { getProductsUrl } from '../../helpers/getStoreUrl';
import { fieldI18nLanguage } from '../../helpers/i18n';
// import createSlug from '../../helpers/createSlug';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import copyToClipboard, {
  getServerUrl,
} from '../../helpers/copyToClipboard';
import {
  DateLink,
  EmailLink,
  PhoneNumberLink,
  // OrderStatusLink,
  StoreLink,
} from '../../components/Links';

import { renderCurrency } from '../../components/SystemCountry';

import Types from '../../modules/types';

// const Rate = styled(AntdRate)`
//   color: ${({ theme }) => theme.less.primaryColor};

//   ${({ disabled }) => disabled && css`
//     .ant-rate-star > div:hover, .ant-rate-star > div:focus {
//       transform: none;
//     }
//   `}
// `;

export const GhostTag = styled(Tag)`
  border-color: ${({ theme }) => theme.less.primaryColor} !important;
  background-color: transparent !important;
  color: ${({ theme }) => theme.less.primaryColor} !important;
  margin-right: 0px !important;
  align-self: center;
`;

export const ValueSpaceBetweenWrapper = styled.span`
display: flex;
justify-content: space-between;
flex-direction: row-reverse;
flex-wrap: wrap;
gap: 3px;
`;

export const DisabledDownloadOutlined = styled(DownloadOutlined)`
color: ${({ theme }) => theme.less.colorDisabled};
pointer-events: none;
`;

export const ValueSpaceBetweenRight = styled.span`
padding-left: 5px;
`;

export const ValueSpaceBetweenLeft = styled.span`
/* margin-right: -9px; */
/* margin-top: -2px; */
display: flex;
flex-wrap: wrap;
justify-content: flex-end;
gap: 5px;
`;

export const DescriptionLabel = styled.span`
display: inline-block;
width: 100%;
/* &:after {
  content: ":";
} */
`;

export const DescriptionValue = styled.span`
display: inline-block;
overflow-wrap: break-word;
a, span {
  word-break: break-word;
}
`;

export const OrderDescription = styled(Descriptions)`
.ant-descriptions-title {
  font-size: 22px;
}
.ant-descriptions-row {
  vertical-align: top;
}
.ant-descriptions-item-label,
.ant-descriptions-item-content {
  vertical-align: top;
  padding: 6px 12px 7px !important;
  width: 100%;
}
.ant-descriptions-item-label {
  color: ${({ theme }) => theme.less.textColor} !important;
  opacity: 0.7;
  min-width: 120px;
  width: 30%;
  flex-shrink: 0;
  white-space: nowrap;
  &.ant-descriptions-item-no-label {
    display: none;
    & + .ant-descriptions-item-content {
      padding: 0px !important;
    }
  }
}
.ant-descriptions-item {
  display: flex;
}
.ant-list-item {
  border-bottom: 0px;
}
`;

export const OrderPopover = styled(Tooltip)`
max-width: 400px;
`;

export const OrderPartyDetailsTitle = styled.span`
`;

export const OrderPopoverIcon = styled(QuestionCircleOutlined)`
opacity: 0.4;
transform: scale(0.7) translateY(2px);
cursor: pointer;
`;

export const OrderDescriptionSectionSeparator = styled.div`
height: 20px;
`;

export const ApplePayMark = styled.img`
width: 30px;
margin-left: 8px;
transform: translateY(-2px);
opacity: 0.6;
`;

export const OrderItemPopoverImage = styled.img`
max-width: min(300px, 70vw);
width: 100%;
height: auto;
`;

export const DescriptionTable = styled(AntdTable)`
width: 100%;
tr {
  vertical-align: top;
}
td {
  padding: 6px 12px 7px !important;
  &:first-child {
    background-color: #fafafa;
  }
}
`;

const FIELDS = [
  ['FieldReact', {
    name: '_all',
    label: null,
    renderContent: (props) => {
      if (!props.data || !props.viewer) {
        return null;
      }
      const { viewer, data } = props;
      if (!data) {
        return null;
      }
      // let cost = data.cost || {};
      let items = data.items || [];
      let isSellerOnResellerOrder = false;
      // const isAdmin = viewer && viewer.role === 'ADMIN';
      if (
        data
        && data.store
        && data.store.type === 'RESELLER'
        && viewer
        && viewer.role === 'SELLER'
        && viewer.store !== data.store._id
      ) {
        isSellerOnResellerOrder = true;
        // cost = data.costs.find(({ store }) => store === viewer.store);
        items = props.data.items.filter(
          ({ originStore }) => originStore === viewer.store,
        );
      }
      // const {
      //   timezone,
      // } = Types.getSystemCountry(data.systemCountry);
      // console.log(props.data);
      return [
        ['Details', [
          (
            viewer && viewer.role === 'ADMIN'
            ? (
                ['Store', (
                  // eslint-disable-next-line react/jsx-key
                  <StoreLink
                    location={props.location}
                    subject={data.store}
                    pathname={getRoleBasedPath(props, '/orders')}
                  />
                )]
              )
            : null
          ),
          // (
          //   data.customer?.name?.length
          //   && data.saleSummaries?.storeCustomer
          //   ? ['Customer', (
          //       <Link
          //         key="customer"
          //         to={getRoleBasedPath(props, `/customers/${
          //           data.saleSummaries?.storeCustomer
          //         }`)}
          //       >
          //         {data.customer.name}
          //       </Link>
          //     )]
          //   : null
          // ),
          // (
          //   data.store?.type === 'RESELLER'
          //   ? ['Reseller Store', data.store.name]
          //   : null
          // ),
          ['Last Updated At', (
            // eslint-disable-next-line react/jsx-key
            <DateLink
              date={props.data.updatedAt}
              location={props.location}
              pathname={getRoleBasedPath(props, '/abandoned-carts')}
            >
              {moment(props.data.updatedAt).format(
                'dddd, MMMM Do YYYY [at] h:mm a'
              )}
            </DateLink>
          )],
          (
            props.data.lastSentAt
            ? [
                'Last Sent At', (
                  props.data.sentCount
                  ? (
                      // eslint-disable-next-line react/jsx-key
                      <DateLink
                        date={props.data.lastSentAt}
                        location={props.location}
                        pathname={getRoleBasedPath(props, '/abandoned-carts')}
                      >
                        {moment(props.data.lastSentAt).format(
                          'dddd, MMMM Do YYYY [at] h:mm a'
                        )}
                      </DateLink>
                    )
                  : '-'
                ),
              ]
            : null
          ),
          ['Sent Count', (
              props?.data?.sentCount > 0
            ? props?.data?.sentCount
            : '-'
          )],
          ['Link', (
            // eslint-disable-next-line react/jsx-key
            <span>
              <a
                href={`${getServerUrl()}/order/${props.data._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${getServerUrl()}/order/${props.data._id}`}
              </a>
              <span>&nbsp;(</span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  onClick={() => copyToClipboard(`${
                    getServerUrl()
                  }/order/${
                    props.data._id
                  }`)}
                >
                  <span>Copy&nbsp;</span>
                  <LinkOutlined />
                </a>
              <span>)</span>
            </span>
          )],
          // (
          //   props.data.comment
          //   ? ['Comment', props.data.comment]
          //   : null
          // ),
        ]],
        (
          props.data.name || props.data.email || props.data.phoneNumberString
          ? (
              ['Customer', [
                ['Name', (
                  // eslint-disable-next-line react/jsx-key
                  <span style={{ textTransform: 'capitalize' }}>
                    {props.data.name}
                  </span>
                )],
                ['First Name', (
                  props.data.firstName || '-'
                )],
                ['Last Name', (
                  props.data.lastName || '-'
                )],
                ['Email', (
                  props.data.email
                  ? (
                      <EmailLink
                        email={props.data.email}
                        orderId={props.data._id}
                      />
                    )
                  : null
                )],
                ['Phone number', (
                  props.data.phoneNumberString
                  ? (
                      <PhoneNumberLink
                        phoneNumberString={
                          props.data.phoneNumberString
                        }
                      />
                    )
                  : null
                )],
              ]]
            )
          : null
        ),
        ['Items', (
          // eslint-disable-next-line react/jsx-key
          <Descriptions.Item>
            <List
              itemLayout="horizontal"
              dataSource={items}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={(
                      <>
                        <Link to={`/products/${item.product}`}>
                          {item.name}
                        </Link>
                      </>
                    )}
                    description={(
                      <>
                        <span>
                          {
                            renderCurrency({
                              suffix: ` x ${item.quantity}`,
                              prefix: `${Types.decimalize(
                                  isSellerOnResellerOrder
                                ? item.priceOrigin
                                : item.price
                              )} `,
                            })
                          }
                          {
                            item.comment
                            ? ` / Comment: ${item.comment}`
                            : ''
                          }
                          {
                            item.options.length
                            ? ` / ${item.options.map(option => `${
                                option.label
                              }: ${
                                option.value || 'N/A'
                              }`).join(' / ')}`
                            : ''
                          }
                          {
                            item.attributes?.length
                            ? (
                                <span style={{ marginLeft: '10px' }}>
                                  {
                                    item.attributes
                                    .map(key => (
                                      <Tag key={key}>
                                        {
                                          Types
                                          .PRODUCT_ATTRIBUTE_LABELS_MAP[key]
                                        }
                                      </Tag>
                                    ))
                                  }
                                </span>
                              )
                            : null
                          }
                        </span>
                      </>
                    )}
                    avatar={(
                        item.image?.src
                        ? (
                          <Tooltip
                            placement="topLeft"
                            title={(
                              <OrderItemPopoverImage
                                alt="Product"
                                src={item.image.src}
                              />
                            )}
                          >
                            <Avatar
                              src={item.image.src}
                              size="large"
                              shape="square"
                              style={{ backgroundColor: '#f8f8f8' }}
                            />
                          </Tooltip>
                        )
                      : (
                        <Avatar
                          src={item.image?.src || null}
                          size="large"
                          shape="square"
                          style={{ backgroundColor: '#f8f8f8' }}
                        />
                      )
                    )}
                  />
                </List.Item>
              )}
            />
          </Descriptions.Item>
        ), false],
      ]
      .reduce(
        // eslint-disable-next-line no-unused-vars
        (sections, section, index, initialSectionsArray) => {
          if (section) {
            sections.push(
              <OrderDescriptionSectionSeparator
                key={`${section[0]}-separator`}
              />
            );
            const {
              valueProps = {},
              ...descriptionProps
            } = section[3] || {};
            sections.push(
              <OrderDescription
                key={section[0]}
                title={section[0]}
                column={1}
                size="small"
                // colon={false}
                bordered={Array.isArray(section[1])}
                {...descriptionProps}
              >
                {
                  Array.isArray(section[1])
                  ? section[1].reduce(
                      (list, item) => {
                        if (item) {
                          list.push(
                            <Descriptions.Item
                              key={item[0]}
                              label={(
                                <DescriptionLabel>
                                  {item[0]}
                                </DescriptionLabel>
                              )}
                            >
                              <DescriptionValue {...valueProps}>
                                {item[1]}
                              </DescriptionValue>
                            </Descriptions.Item>
                          );
                        }
                        return list;
                      },
                      [],
                    )
                  : section[1]
                }
              </OrderDescription>
            );
          }
          return sections;
        },
        [],
      );
    },
  }],
];

export const ADMIN = [
  fieldI18nLanguage,
  ...FIELDS,
];

export const SELLER = [
  fieldI18nLanguage,
  ...FIELDS,
];
